module.exports = __webpack_public_path__ + "img/p1_r.8facb057.jpg";